import React from 'react';
import { Link } from 'react-router-dom';
import TableMountImage from './assets/Table Mount.png';

function TableMountainPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage table-mountain-hero">
        <div className="hero-content">
          <h1>Experience Majestic Table Mountain</h1>
          <p>An iconic landmark offering breathtaking panoramic views of Cape Town.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Ascend to Cape Town's Crown Jewel</h2>
          <div className="content-intro">
            <img src={TableMountImage} alt="Table Mountain" className="tour-main-image" />
            <p>No visit to Cape Town is complete without a journey to the summit of Table Mountain. As one of the New7Wonders of Nature, this flat-topped mountain provides unparalleled views of the city, coastline, and surrounding natural beauty. Ebamba Travel & Tours ensures a smooth and memorable experience, whether you choose the revolving cableway or a guided hike.</p>
            <p>From the bustling city bowl to the vast expanse of the Atlantic Ocean, the perspectives from Table Mountain are truly awe-inspiring. Spend time exploring the various pathways at the top, capturing incredible photographs, and simply soaking in the majestic scenery.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Table Mountain Visit</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-mountain"></i>
              <h4>Panoramic Views</h4>
              <p>Enjoy 360-degree vistas of Cape Town, Lion's Head, Robben Island, and the Twelve Apostles mountain range.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-cable-car"></i>
              <h4>Revolving Cableway</h4>
              <p>Ascend in the modern, revolving Table Mountain Aerial Cableway for spectacular views on the way up and down.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-hiking"></i>
              <h4>Nature Walks</h4>
              <p>Explore easy walking paths at the summit, discovering unique fynbos flora and small wildlife.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-camera-retro"></i>
              <h4>Photo Opportunities</h4>
              <p>Capture iconic shots of the mountain and its surroundings – perfect for your travel album.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Travelers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Table Mountain with Ebamba was seamless! Our guide helped us beat the queues, and the views from the top were absolutely incredible. A truly iconic experience."</p>
              <span>– Emily K. from USA</span>
            </div>
            <div className="testimonial-card">
              <p>"Breathtaking doesn't even begin to describe it. Ebamba organized everything perfectly, and we had ample time to explore and enjoy the magnificent scenery."</p>
              <span>– Chen L. from China</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Table Mountain Experience</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TableMountainPage;
